import React, {useEffect, useState} from "react";
import {Colors} from "../../../assets/colors/Colors";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import {FormProvider, useForm, useFormContext, useWatch} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {convertToString, validArray} from "../../../util/functions";
import {adminService} from "../../../services/apiAdmin";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {modalSideService} from "../../../services/modalSideService";
import {isEmpty} from "../../../util/is";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import {ERRORFIELDREQUIRED, optionsEstados} from "../../../data/ConstantForm";
import {CButton} from "@coreui/react";
import AutocompleteForm from "../../../components/ComponentesFormularios/Autocomplete";
import {ConstantsFormCrud} from "../../../data/RoutesFormCrud";


const ComponentRoles = ({className, roles, onChange}) => {

  const dispatch = useDispatch();
  const [ state, setState ] = useState(Object.assign({}, roles));
  const generalServicesState = useSelector( state => state.generalServices )

  const handleChangeRol = (type, item) => {

    switch(type){

      case "C":
        if(isEmpty(state[item.id])){
          setState({...state, [item.id] : { boCrear: "S", boEliminar: "N", boActualizar: "N", boConsultar: "N"}})
        }
        else{
          setState({...state, [item.id] : { boCrear: convertToString(state[item.id].boCrear) === "S" ? "N" : "S",
              boEliminar: state[item.id].boEliminar,
              boActualizar: state[item.id].boActualizar,
              boConsultar: state[item.id].boConsultar}})
        }
        break;
      case "R":
        if(isEmpty(state[item.id])){
          setState({...state, [item.id] : { boCrear: "N", boEliminar: "N", boActualizar: "N", boConsultar: "S" }})
        }
        else{
          setState({...state, [item.id] : { boCrear: state[item.id].boCrear,
              boEliminar: state[item.id].boEliminar,
              boActualizar: state[item.id].boActualizar,
              boConsultar: convertToString(state[item.id].boConsultar) === "S" ? "N" : "S"}})
        }
        break;
      case "U":
        if(isEmpty(state[item.id])){
          setState({...state, [item.id] : { boCrear: "N", boEliminar: "N", boActualizar: "S", boConsultar: "N" }})
        }
        else{
          setState({...state, [item.id] : { boCrear: state[item.id].boCrear,
              boEliminar: state[item.id].boEliminar,
              boActualizar: convertToString(state[item.id].boActualizar) === "S" ? "N" : "S",
              boConsultar: state[item.id].boConsultar}})
        }
        break;
      case "D":
        if(isEmpty(state[item.id])){
          setState({...state, [item.id] : { boCrear: "N", boEliminar: "S", boActualizar: "N", boConsultar: "N" }})
        }
        else{
          setState({...state, [item.id] : { boCrear: state[item.id].boCrear,
              boEliminar: convertToString(state[item.id].boEliminar) === "S" ? "N" : "S",
              boActualizar: state[item.id].boActualizar,
              boConsultar: state[item.id].boConsultar}})
        }
        break;

    }

  }

  const handleOpenDetailRol = (rol) => {


    adminService.getMenusByRol(rol.id).then(
      response => {

        const { status, msg, data } = response;

        if(status){

          modalSideService.showModal({
            type: ConstantsFormCrud.modalShowDetailRoles,
            props: {idRol: rol.id, nmRol: rol.text, data},
            title: `Información del rol ${rol.id} (${rol.text})`,
            isAddMode: false,
            isEditable: false,
            dense: true,
            size: 'xl'
          })

          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

        }
        else{
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
        }

      },
      error => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
      }
    )




  }

  useEffect(() => {
    onChange(state);
  }, [state])

  return(
    <div className="mx-2">
      <header className="mx-2 text-center text-muted content-divider divider-form">
        <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Roles Usuario</span>
      </header>
      <div className="row mx-0 px-0 mb-2 mt-4" style={{border: "1px dashed gray", borderRadius: 10}}>
        <div className={className}>
          {
            generalServicesState?.arrRoles?.map((item, index) => (

              <div key={`itemRol${item.id}${index}`} className="my-2 d-flex align-items-center">
                <div onClick={() => handleOpenDetailRol(item)} className="w-50 text-overflow-card-punto-venta-oneline cursor-pointer"><span className="font-weight-bold" style={{fontSize: 12}}>{item.id}</span></div>
                <div className="w-50 text-right d-flex align-items-center justify-content-end">
                  <i onClick={() => handleChangeRol("C", item)} style={{color: convertToString(state[item.id]?.boCrear) === "S" ? Colors.GREEN_SWITCH_ACTIVE : Colors.DARK_GRAY, cursor: "pointer"}} className="far fa-plus-circle p-1"/>
                  <i onClick={() => handleChangeRol("R", item)} style={{color: convertToString(state[item.id]?.boConsultar) === "S" ? Colors.COLOR_AMOVIL_BLUE_DARK : Colors.DARK_GRAY, cursor: "pointer"}} className="far fa-eye p-1"/>
                  <i onClick={() => handleChangeRol("U", item)} style={{color: convertToString(state[item.id]?.boActualizar) === "S" ? Colors.COLOR_BLUE_THEME : Colors.DARK_GRAY, cursor: "pointer"}} className="fas fa-sync-alt p-1"/>
                  <i onClick={() => handleChangeRol("D", item)} style={{color: convertToString(state[item.id]?.boEliminar) === "S" ? Colors.RED_SWITCH_INACTIVE : Colors.DARK_GRAY, cursor: "pointer"}} className="far fa-trash-alt p-1"/>
                </div>
              </div>

            ))
          }
        </div>
      </div>
    </div>
  )
}

const Roles = () => {

  const { control, setValue, getValue } = useFormContext();

  const roles = useWatch({
    control,
    name: 'roles'
  })

  console.log(roles)

  const onChangeRoles = (stateRoles) => {
    setValue("roles", stateRoles);
  }

  return(
    <ComponentRoles className={`px-3 py-2 col-12`} roles={roles} onChange={(stateRoles) => onChangeRoles(stateRoles)}/>
  )

}


const FormMenuCRUD = ({ isEditing, isAddMode, isAddModeFromNode, properties }) => {

    const { id, data, function: executeFunction } = properties;
    const generalServicesState = useSelector( state => state.generalServices );
    const dispatch = useDispatch();
    const authState = useSelector( state => state.auth )
    const { idUsuario: idUsuarioAuditoria } = authState;
    const methods = useForm({defaultValues: { ...data, id: isAddModeFromNode || isAddMode ? "" : id,
            idMenuPadre: isAddMode ? "0" : isAddModeFromNode ? id : convertToString(data?.idMenuPadre) }});
    const { setValue, register, watch, handleSubmit, control, formState: {errors} } = methods;

    const onSuccessSubmit = data => {

        let formatRoles = [];
        for(let item in data.roles){
          formatRoles.push({...data.roles[item], nmRol: item});
        }
        data.jsRoles = formatRoles.slice();

        data.accion = (isAddMode || isAddModeFromNode) ? "C" : "A";
        adminService.setCrudMenu(data).then(
            response => {

                const {status, msg, data: datos} = response;

                if (status) {
                    if(datos?.idmsg === 200){

                        if(isAddMode || isAddModeFromNode){
                            executeFunction({item: data, idRegNuevo: datos?.idreg});
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: datos?.txmsg } });
                        }
                        else{
                            executeFunction({newState: data, item: data});
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: datos?.txmsg } });
                        }

                        modalSideService.clear();
                    }
                    else{
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: datos?.txmsg } });
                    }


                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                }


            },
            error => {
                 dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
            }
        );
    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    useEffect(() => {
      register("roles", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
    }, [])

    return(
        <FormProvider {...methods} className="d-flex flex-column justify-content-between align-items-center h-100" style={{overflowY: "auto"}}>

            <div className="container mx-0 px-0 w-100 mw-100 my-3">
                <header className="mx-2 text-center text-muted content-divider divider-form">
                    <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Información Menu</span>
                </header>
                <div className="row mx-0 px-0 my-2">
                    <InputForm inputProps={{control}} readOnly={true} disabled={!isEditing} identificador="id" label="ID Menu" handleChange={({name, value}) => setValue(name, value)}
                               placeholder="Automatico" type="text" required={false} className={`px-2 col-12`} textUppercase={false}/>
                    <InputForm inputProps={{control}} readOnly={true} disabled={!isEditing} identificador="idMenuPadre" label="ID Menu Padre" handleChange={({name, value}) => setValue(name, value)}
                               placeholder="Ej: 1" type="text" required={true} className={`px-2 col-12`} textUppercase={false}/>
                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="nombre" label="Nombre" handleChange={({name, value}) => setValue(name, value)}
                               placeholder="Ej: Menu" type="text" required={true} className={`px-2 col-12`} textUppercase={false}/>
                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="descripcion" label="Descripción" handleChange={({name, value}) => setValue(name, value)}
                               placeholder="Ej: Descripción" type="text" required={true} className={`px-2 col-12`} textUppercase={false}/>
                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="ruta" label="Ruta" handleChange={({name, value}) => setValue(name, value)}
                               placeholder="Ej: ruta/component" type="text" required={true} className={`px-2 col-12`} textUppercase={false}/>
                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="orden" label="Orden" handleChange={({name, value}) => setValue(name, value)}
                               placeholder="Ej: 5" type="number" required={true} className={`px-2 col-12`} textUppercase={false}/>
                    <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true} handleChange={({name, value}) => setValue(name, value)}
                                     defaultValue="1" label="Estado" className={`px-2 col-12`}/>

                </div>



              <Roles/>



            </div>

            <div className="w-100 mb-2">
                {
                    isEditing &&
                    <CButton onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)} style={{borderRadius: 100, letterSpacing: 1.3}}
                             color="info" className="mt-4 w-100 p-2 text-uppercase" shape="rounded-pill">Guardar Cambios</CButton>
                }
            </div>

        </FormProvider>
    )

}

export default FormMenuCRUD;
